// extracted by mini-css-extract-plugin
export default {"wrapper":"A_ContextMenuItem_wrapper__doPik","danger":"A_ContextMenuItem_danger__k76oS"};